import { IconProps } from "@design-system/types";

export function ArabicLogoIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="304"
      height="57"
      viewBox="0 0 304 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_792_13848"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="304"
        height="57"
      >
        <path d="M304 0H0V57H304V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_792_13848)">
        <path
          d="M239.747 23.4699C238.239 22.0535 237.379 20.0699 237.379 17.8725C237.379 13.6584 240.728 10.2292 244.842 10.2292H257.827L257.985 10.1165L271.799 0H244.842C235.219 0 227.392 8.01823 227.392 17.8725C227.392 22.2148 228.913 26.291 231.561 29.4656L239.749 23.4699H239.747Z"
          fill="white"
        />
        <path
          d="M289.086 0C284.827 0 280.671 1.3503 277.19 3.86437L267.967 10.5265L236.503 33.5651C236.605 33.6214 236.704 33.6855 236.808 33.7419C239.348 35.0902 242.105 35.7586 244.85 35.7586C248.378 35.7586 251.889 34.655 254.898 32.4829L299.904 0H289.086Z"
          fill="white"
        />
        <path
          d="M291.643 33.5299C293.151 34.9462 294.012 36.9299 294.012 39.1273C294.012 43.3414 290.664 46.7706 286.55 46.7706H273.565L273.405 46.8832L259.591 56.9998H286.55C296.171 56.9998 304 48.9816 304 39.1273C304 34.785 302.477 30.7088 299.83 27.5342L291.643 33.5299Z"
          fill="white"
        />
        <path
          d="M242.304 56.9998C246.565 56.9998 250.719 55.6495 254.2 53.1354L263.425 46.4733L294.887 23.4347C294.784 23.3784 294.686 23.3143 294.581 23.2579C292.039 21.9096 289.285 21.2412 286.54 21.2412C283.01 21.2412 279.5 22.3448 276.492 24.5169L231.483 56.9978H242.302L242.304 56.9998Z"
          fill="white"
        />
        <path
          d="M191.193 25.0243L194.444 22.6812C194.408 22.7064 194.37 22.7297 194.334 22.755L191.193 25.0243Z"
          fill="white"
        />
        <path
          d="M141.613 19.2012H133.989V47.2174H141.613V19.2012Z"
          fill="white"
        />
        <path d="M128.4 4.99902H120.776V47.2176H128.4V4.99902Z" fill="white" />
        <path
          d="M58.8639 39.4092H7.84979L0 47.2176H58.8639H60.4745H66.488V19.4209H58.8639V39.4092Z"
          fill="white"
        />
        <path
          d="M137.803 3.50112L132.26 9.17773L137.803 14.8544L143.345 9.17773L137.803 3.50112Z"
          fill="white"
        />
        <path
          d="M45.8468 15.5597L40.3042 21.2363L45.8468 26.9129L51.3894 21.2363L45.8468 15.5597Z"
          fill="white"
        />
        <path
          d="M40.3039 21.2357L34.7609 15.5586L29.2197 21.2357L34.7609 26.9108L40.3039 21.2357Z"
          fill="white"
        />
        <path
          d="M93.6948 32.2731C93.6948 28.3388 96.8192 25.1388 100.661 25.1388C102.677 25.1388 104.593 26.0326 105.919 27.5927L111.671 22.4654C108.895 19.2014 104.883 17.3304 100.661 17.3304C92.6154 17.3304 86.0708 24.0333 86.0708 32.2731C86.0708 34.8551 86.7139 37.2857 87.8445 39.4073H79.6988V4.99902H72.0747V47.2176H115.19V39.4092H100.661C96.8192 39.4092 93.6948 36.2093 93.6948 32.275"
          fill="white"
        />
        <path
          d="M210.229 17.3247L203.596 22.1042C203.596 22.1042 203.605 22.108 203.607 22.11C206.631 23.7167 208.437 26.7573 208.437 30.2448C208.437 35.2982 204.423 39.4074 199.489 39.4074H179.614L168.801 47.2158H199.489C208.626 47.2158 216.059 39.6017 216.059 30.2429C216.059 25.1836 213.887 20.5032 210.227 17.3228"
          fill="white"
        />
        <path
          d="M194.334 22.7566C194.371 22.7294 194.408 22.7081 194.446 22.6828L205.749 14.5383C200.538 12.3526 194.606 13.0054 189.941 16.3763L161.211 37.1242L153.587 42.607L147.2 47.2194H153.856C158.109 47.2194 162.256 45.8749 165.733 43.3686L191.193 25.0259L194.333 22.7566H194.334Z"
          fill="white"
        />
        <path
          d="M154.824 19.2012H147.2V41.21L154.824 35.7039V19.2012Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
